<template>
  <div id="introducao">
    <h1 class="titulo">{{titulo}}</h1>
    <div class="content-img-doc">
      <img class="img-fluid mx-auto d-block"
           :class="classe_imagem"
           :src="src_imagem"
           :title="titulo"
           :alt="titulo">
    </div>
    <div class="dicas">
      <ul class="list-group">
        <li v-for="dica in dicas"  class="list-group-item">
          <p class="txt-subtitulo">{{dica.titulo}}</p>
          <p v-if="dica.subtitulo" class="txt-padrao">{{dica.subtitulo}}</p>
        </li>
      </ul>
    </div>

    <div id="footer" class="footer-shadow">
      <button type="button"  v-on:click="clicaNoBotao()" class="btn btn-primary btn-lg btn-block">
        {{btn_title}}
      </button>
    </div>
  </div>
</template>

<script>
import DispatchTags from "../../utils/DispatchTags";

export default {
  name: "DocIntroducao",
  mounted() {
    this.dispathGtmScreenView();
  },
  beforeUpdate(){
    this.dispathGtmScreenView();
  },
  data:function (){
    return {
      dados:{
        CNH:{
          classe:'imagem-cnh-outro',
          frente:{
            titulo:'Primeiro, vamos tirar a foto apenas da frente da CNH',
            imagem:'./ilustra_frente_cnh.png',
            btn_title:'Tirar foto da frente da CNH',
            sn_gtm: 'DocIntroducaoCnhFront',
            in_gtm:'DocIntroducaoCnhFront',
            dicas:[
              {titulo: 'Coloque a frente da CNH na moldura'},
              {
                titulo: 'O documento precisa estar legível',
                subtitulo:'Todas as linhas, textos e foto devem estar bem visíveis e possíveis de serem lidas'
              }
            ],
          },
          verso:{
            titulo:'Agora, vamos tirar a foto da parte de trás (verso) da CNH',
            imagem:'./ilustra_verso_cnh.png',
            btn_title:'Tirar foto do verso da CNH',
            sn_gtm: 'DocIntroducaoCnhBack',
            in_gtm:'DocIntroducaoCnhBack',
            dicas:[
              {titulo: 'Coloque o verso da CNH na moldura'},
              {
                titulo: 'O documento precisa estar legível',
                subtitulo:'Todas as linhas, textos e foto devem estar bem visíveis e possíveis de serem lidas'
              }
            ],
          }
        },
        RG:{
          classe:'imagem-rg',
          frente:{
            titulo:'Primeiro, vamos tirar a foto apenas da frente do RG',
            imagem:'./ilustra_frente_rg.png',
            btn_title:'Tirar foto da frente do RG',
            sn_gtm: 'DocIntroducaoRgFront',
            in_gtm:'DocIntroducaoRgFront',
            dicas:[
              {titulo: 'Coloque a frente do RG na moldura'},
              {
                titulo: 'O documento precisa estar legível',
                subtitulo:'Todas as linhas, textos e foto devem estar bem visíveis e possíveis de serem lidas'
              }
            ]
          },
          verso:{
            titulo:'Agora, vamos tirar a foto apenas da parte de trás (verso) do RG',
            imagem:'./ilustra_verso_rg.png',
            btn_title:'Tirar foto do verso do RG',
            sn_gtm: 'DocIntroducaoRgBack',
            in_gtm:'DocIntroducaoRgBack',
            dicas:[
              {titulo: 'Coloque o verso do RG na moldura'},
              {
                titulo: 'O documento precisa estar legível',
                subtitulo:'Todas as linhas, textos e foto devem estar bem visíveis e possíveis de serem lidas'
              }
            ]
          }
        },
        OUTRO:{
          classe:'imagem-cnh-outro',
          frente:{
            titulo:'Primeiro, vamos tirar a foto apenas da frente do documento',
            imagem:'./ilustra_frente_outro_doc.png',
            btn_title:'Tirar foto da frente do documento',
            sn_gtm:'DocIntroducaoOutrosFront',
            in_gtm:'DocIntroducaoOutrosFront',
            dicas:[
              {titulo: 'Enquadre a frente do documento'},
              {titulo: 'Apenas documentos com CPF e foto'},
              {
                titulo: 'O documento precisa estar legível',
                subtitulo:'Todas as linhas, textos e foto devem estar bem visíveis e possíveis de serem lidas'
              }
            ],
          },
          verso:{
            titulo:'Agora, vamos tirar a foto apenas da parte de trás (verso) do documento',
            imagem:'./ilustra_verso_outro_doc.png',
            btn_title:'Tirar foto do verso do documento',
            sn_gtm:'DocIntroducaoOutrosBack',
            in_gtm:'DocIntroducaoOutrosBack',
            dicas:[
              {titulo: 'Enquadre o verso do documento'},
              {
                titulo: 'O documento precisa estar legível',
                subtitulo:'Todas as linhas, textos e foto devem estar bem visíveis e possíveis de serem lidas'
              }
            ],
          }
        }
      }
    };
  },
  props:{
    frente: {type: Boolean},
    callback: {type: Function}
  },
  computed:{
    titulo:function(){
      let tipo_doc = this.$store.getters.tipoDoc;
      let dados = this.dados[tipo_doc][this.lado()];
      return dados.titulo;
    },
    btn_title:function (){
      let tipo_doc = this.$store.getters.tipoDoc;
      let dados = this.dados[tipo_doc][this.lado()];
      return dados.btn_title;
    },
    classe_imagem:function (){
      let tipo_doc = this.$store.getters.tipoDoc;
      let dados = this.dados[tipo_doc];
      return `${dados.classe}`;
    },
    dicas:function (){
      let tipo_doc = this.$store.getters.tipoDoc;
      let dados = this.dados[tipo_doc][this.lado()];
      return dados.dicas;
    },
    src_imagem:function (){
      let tipo_doc = this.$store.getters.tipoDoc;
      let dados = this.dados[tipo_doc][this.lado()];
      let images = require.context('../../assets/img/dicas-doc/', false, /\.png$/);
      return images(dados.imagem);
    }
  },
  methods:{
    lado(){
      return (this.frente) ? 'frente' : 'verso';
    },
    dispathGtmScreenView(){
      let tipo_doc = this.$store.getters.tipoDoc;
      let data = this.dados[tipo_doc][this.lado()];
      DispatchTags.dispatchScreenView(data.sn_gtm);
    },
    clicaNoBotao(){
      let tipo_doc = this.$store.getters.tipoDoc;
      let data = this.dados[tipo_doc][this.lado()];
      DispatchTags.dispatchInraction(data.in_gtm);
      this.callback();
    }
  },
}
</script>

<style scoped>
#introducao{
  margin-top: -40px;
}
.content-img-doc{
  margin: 15px 0;
}
.dicas li p{
  margin: 0;
}
.dicas ul li{
  border: 0;
  border-bottom: 1px solid #EEE;
  padding: 0.4rem;
}

@media screen and (max-device-height: 670px){
  .content-img-doc{
    margin: 20px 0;
  }
  #introducao{
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/DocIntroducao.vue